import Settings from '../../utils/Settings';

export const settings = new Settings();

export default async () => {
  //@TODO: call curator endpoint for languages based on app type
  return {
    hostAppLanguages: [
      {
        hostApp: 'SPRK',
        supportedLanguageCodes: [
          'en',
          'no',
          'de',
          'hi',
          'fi',
          'sv',
          'ru',
          'ko',
          'zh-hans',
          'it',
          'fr',
          'es',
          'cs',
          'ja',
          'pl',
          'po',
          'pt',
          'ro',
          'tr',
          'nl',
        ],
      },
    ],
    languages: [
      {
        code: 'en',
        name: 'English',
      },
      {
        code: 'no',
        name: 'Norwegian',
      },
      {
        code: 'de',
        name: 'German',
      },
      {
        code: 'hi',
        name: 'Hindi',
      },
      {
        code: 'fi',
        name: 'Finnish',
      },
      {
        code: 'sv',
        name: 'Swedish',
      },
      {
        code: 'ru',
        name: 'Russian',
      },
      {
        code: 'ko',
        name: 'Korean',
      },
      {
        code: 'zh-hans',
        name: 'Simple Chinese',
      },
      {
        code: 'it',
        name: 'Italian',
      },
      {
        code: 'fr',
        name: 'French',
      },
      {
        code: 'es',
        name: 'Spanish',
      },
      {
        code: 'cs',
        name: 'Czech',
      },
      {
        code: 'ja',
        name: 'Japanese',
      },
      {
        code: 'pl',
        name: 'Polish',
      },
      {
        code: 'po',
        name: 'Polish',
      },
      {
        code: 'pt',
        name: 'Brazilian Portuguese',
      },
      {
        code: 'ro',
        name: 'Romanian',
      },
      {
        code: 'tr',
        name: 'Turkish',
      },
      {
        code: 'nl',
        name: 'Dutch',
      },
    ],
  };
};
